import { ResponseService } from './../services/response.service';
import { NotificationsService } from 'angular2-notifications';
import { Router } from '@angular/router';
import { ApiService } from './../services/api.service';
import { ActivatedRoute } from '@angular/router';
import { BreadcrumbService } from 'ng2-breadcrumb/ng2-breadcrumb';
import { CustomValidators } from 'ng2-validation';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-main',
  templateUrl: './new-password.component.html'
})
export class NewPasswordComponent implements OnInit {

  token: string = '';
  private sub: any;

  loading: Boolean = false;
  newPasswordForm: FormGroup;

  constructor(
    private breadcrumbsService: BreadcrumbService,
    private route: ActivatedRoute,
    private router: Router,
    private apiService: ApiService,
    private notificationService: NotificationsService,
    private responseService: ResponseService
  ) {
  }

  ngOnInit() {
    this.sub = this.route.params.subscribe(params => {
        this.token = params['token'];

        const token = new FormControl(this.token, [Validators.required]);
        const email = new FormControl('', [Validators.required, CustomValidators.email]);
        const password = new FormControl('', [Validators.required, Validators.minLength(8)]);
        const password_confirmation = new FormControl('', [Validators.required, Validators.minLength(8), CustomValidators.equalTo(password)]);

        this.newPasswordForm = new FormGroup({
          token: token,
          email: email,
          password: password,
          password_confirmation: password_confirmation
        });
    });
  }

  ngOnDestroy() {
    this.sub.unsubscribe();
  }

  createNewPassword () {
    this.apiService.post('/password/reset', this.newPasswordForm.value).subscribe(
      (response) => {
        this.responseService.success(true, response);
        this.router.navigateByUrl('/login');
      },
      (error) => {
        this.responseService.error(error);
      }
    )
  }
}



// WEBPACK FOOTER //
// ./src/app/login/new-password.component.ts